import type { CompetitorFormSchema } from '../schemas';

export const defaultValues: Readonly<CompetitorFormSchema> = {
  id: -1,
  name: '',
  logo: null,
  status: { name: '', value: '' },
  business_tagline: '',
  number_of_customers: null,
  founded_date: '',
  headcount: null,
  email: '',
  website: '',
  pricing_strategy: '',
  tidbits: '',
  weaknesses: '',
  strengths: '',
  how_to_win: '',
  behavior: null,
  glassdoor_url: '',
  associated_clients_count: null,
  primary_contact_count: null,
  primary_contact: null,
} as const;
